import { create } from 'zustand';

type SensitiveValuesVisibilityStore = {
  isVisible: boolean;
  toggleVisibility: () => void;
};

export const useSensitiveValuesVisibilityStore = create<SensitiveValuesVisibilityStore>(
  (set, get) => ({
    isVisible: true,
    toggleVisibility: () => set({ isVisible: !get().isVisible }),
  }),
);
